// extracted by mini-css-extract-plugin
module.exports = {"workspaceLabel":"create-workspace-step_workspaceLabel_1DO","workspaceText":"create-workspace-step_workspaceText_kNB"};